import AsyncStorage from '@react-native-async-storage/async-storage';
import type { User } from '../../../data/domains/profile';
import { AUTH_TOKEN_KEY, CURRENT_USER_KEY } from './keys';

/** Write session token + user snapshot to AsyncStorage (login / register completion). */
export async function persistSessionUser(user: User): Promise<void> {
    const token = user.session_token;
  if (!token) {
    return;
  }
  await AsyncStorage.setItem(AUTH_TOKEN_KEY, token);
  await AsyncStorage.setItem(CURRENT_USER_KEY, JSON.stringify(user));
}
